export default __webpack_public_path__ + "static/media/causes_gold.92de64b9.svg";